import { SyntheticEvent, useCallback, useState } from "react";
import FocusLock from "react-focus-lock";
import { Button, TextInput } from "@/shared/ui";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
  code: string;
  onCodeChange: (value: string) => void;
  error?: string;
  pending?: boolean;
  disableSubmitButton?: boolean;
  onResetAccess: () => void;
};

export default function AuthResetTfaAuthenticator({
  onSubmit,
  code,
  onCodeChange,
  error = "",
  pending = false,
  disableSubmitButton,
  onResetAccess,
}: Props) {
  const [showCode, setShowCode] = useState(false);
  const [touch, setTouch] = useState(false);

  const toogleShowCode = useCallback(() => {
    setShowCode((state) => !state);
  }, []);

  return (
    <FocusLock className="grow flex flex-col w-full">
      <form
        noValidate
        onSubmit={(e) => {
          onSubmit(e);
          setTouch(true);
        }}
        className="gap-3 grow flex flex-col"
      >
        <div>
          <div className="text-white text-16 font-medium">Authenticator Код:</div>
          <div className="text-white/60 text-15 font-medium mt-1">
            Если у вас есть recovery код от приложения Authenticator, введите его.
          </div>
          <TextInput
            type="password"
            placeholder="Введите код"
            value={code}
            invalid={touch && !code ? "Введите код" : ""}
            onChange={onCodeChange}
            className="text-left mt-2.5"
            loading={pending}
            passwordVisible={showCode}
            onChangePasswordVisible={toogleShowCode}
          />
          <button
            type="button"
            className="text-white text-center w-fit underline decoration-1 underline-offset-2 hover:text-white/75 transition outline-none mt-2.5"
            onClick={onResetAccess}
            disabled={pending}
          >
            Нет кода?
          </button>
        </div>
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit className="w-full" loading={pending} disabled={disableSubmitButton}>
            Отправить код
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
